// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgTelegram = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.764 2.203a.75.75 0 0 1 .206.758l-4.25 14.5a.75.75 0 0 1-1.274.294l-5.07-5.565-5.06-3.578a.75.75 0 0 1 .179-1.317l14.5-5.25a.75.75 0 0 1 .769.158Zm-8.792 9.512 3.684 4.043 3.458-11.8-11.76 4.259 3.496 2.472L9.785 9.16a.75.75 0 1 1 .93 1.178l-1.743 1.376Z"
      fill="#fff"
    />
  </svg>
)

export default SvgTelegram
